import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function PageHeader({
  icone: Icone,
  titre,
  description,
  actions,
}: {
  icone: LucideIcon;
  titre: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center gap-4">
      <span className="grid size-14 place-items-center rounded-[14px] bg-primary-subtle text-primary">
        <Icone className="size-[26px]" aria-hidden />
      </span>
      <div className="min-w-0">
        <h1 className="text-[26px] leading-tight font-bold">{titre}</h1>
        {description ? <p className="mt-0.5 text-[13px] text-muted">{description}</p> : null}
      </div>
      {actions ? <div className="ml-auto flex gap-2">{actions}</div> : null}
    </div>
  );
}
